/**
 * The icon for open quotes.
 * https://www.figma.com/design/rR8akVWS3SksIyaOSqetu4/BAU--WEB-?node-id=12572-16975&m=dev
 */
const IconOpenQuotes = () => {
  return (
    <path
      d="M3.16616 26.5815C1.10616 24.3935 0.000160829 21.9394 0.000161177 17.9614C0.000161789 10.9614 4.91216 4.68745 12.0602 1.58545L13.8462 4.34145C7.17616 7.94945 5.87216 12.6314 5.35016 15.5834C6.42416 15.0274 7.83016 14.8334 9.21016 14.9614C12.8182 15.2954 15.6622 18.2575 15.6622 21.9395C15.6622 23.796 14.9247 25.5764 13.6119 26.8892C12.2992 28.202 10.5187 28.9395 8.66216 28.9395C6.51616 28.9395 4.46216 27.9595 3.16616 26.5815ZM20.1662 26.5815C18.1062 24.3935 17.0002 21.9395 17.0002 17.9615C17.0002 10.9615 21.9122 4.68745 29.0602 1.58545L30.8462 4.34145C24.1762 7.94945 22.8722 12.6314 22.3522 15.5835C23.4262 15.0275 24.8322 14.8335 26.2102 14.9615C29.8182 15.2935 32.6602 18.2555 32.6602 21.9395C32.6602 23.796 31.9227 25.5764 30.6099 26.8892C29.2972 28.202 27.5167 28.9395 25.6602 28.9395C23.5142 28.9395 21.4602 27.9595 20.1642 26.5815"
      fill="currentColor"
    />
  );
};

export default IconOpenQuotes;
